export default function draw_label(d) {
    const {
        thetext,
        svg,
        fillColor,
        fontSize = 24,
        fontWeight = 'bold',
        fontFamily = 'Arial',
        x,
        y,
        textAnchor = 'middle',
        wrap_width,
        wrap_line_height = 24,
        wrap_direction = 'down',
    } = d

    if (!thetext) {
        throw new Error(
            'The provided svg parameter is not a valid SVG element.'
        )
    }

    // Ensure svg is an SVG element
    if (!(svg instanceof SVGElement)) {
        throw new Error(
            'The provided svg parameter is not a valid SVG element.'
        )
    }

    const words = thetext.split(' ')
    let line = ''
    const lines = []

    // Create a temporary text element to measure text width
    const tempText = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'text'
    )
    tempText.setAttribute('x', x)
    tempText.setAttribute('y', y)
    tempText.setAttribute('fill', fillColor)
    tempText.setAttribute('font-size', fontSize)
    tempText.setAttribute('font-weight', fontWeight)
    tempText.setAttribute('font-family', fontFamily)
    tempText.setAttribute('text-anchor', textAnchor)
    tempText.style.visibility = 'hidden'
    svg.appendChild(tempText)

    words.forEach((word) => {
        const testLine = `${line + word} `
        tempText.textContent = testLine
        const testWidth = tempText.getComputedTextLength()

        if (testWidth > wrap_width && line !== '') {
            lines.push(line)
            line = `${word} `
        } else {
            line = testLine
        }
    })

    lines.push(line.trim())
    svg.removeChild(tempText)

    let offset_multiplier

    switch (wrap_direction) {
        case 'up':
            offset_multiplier = -1
            break
        case 'center':
            offset_multiplier = -0.5
            break
        default:
            offset_multiplier = 1
    }

    const offsetY = (lines.length - 1) * wrap_line_height * offset_multiplier

    const els = lines.map((l, i) => {
        const dy = y + i * wrap_line_height + offsetY
        const textElement = document.createElementNS(
            'http://www.w3.org/2000/svg',
            'text'
        )
        textElement.setAttribute('x', x)
        textElement.setAttribute('y', dy)
        textElement.setAttribute('fill', fillColor)
        textElement.setAttribute('font-size', fontSize)
        textElement.setAttribute('font-weight', fontWeight)
        textElement.setAttribute('font-family', fontFamily)
        textElement.setAttribute('text-anchor', textAnchor)
        textElement.textContent = l
        svg.appendChild(textElement)

        return textElement
    })

    return els
}
